import { useEffect, useMemo, useState } from 'react';
import { buildEventAppSchemeUrl } from '../utils/eventDeepLinks';

function DeepLinkRedirect({ colla, eventType, eventId }) {
    const [showFallback, setShowFallback] = useState(false);
    const appUrl = useMemo(() => buildEventAppSchemeUrl({
        colla,
        eventType,
        eventId,
    }), [colla, eventType, eventId]);

    useEffect(() => {
        if (!appUrl) return undefined;

        let appOpened = false;
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = appUrl;

        const handleVisibilityChange = () => {
            if (document.hidden) {
                appOpened = true;
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        document.body.appendChild(iframe);

        const openTimer = setTimeout(() => {
            if (!appOpened) {
                window.location.href = appUrl;
            }
        }, 100);

        const fallbackTimer = setTimeout(() => {
            setShowFallback(true);
        }, 2500);

        return () => {
            clearTimeout(openTimer);
            clearTimeout(fallbackTimer);
            document.removeEventListener('visibilitychange', handleVisibilityChange);

            if (iframe.parentNode) {
                iframe.parentNode.removeChild(iframe);
            }
        };
    }, [appUrl]);

    if (!appUrl) {
        return (
            <div style={styles.page}>
                <div style={styles.container}>
                    <h1 style={styles.title}>Enllaç no vàlid</h1>
                    <p style={styles.text}>Aquest enllaç d'Aleta no apunta a cap esdeveniment.</p>
                </div>
            </div>
        );
    }

    return (
        <div style={styles.page}>
            <div style={styles.container}>
                <h1 style={styles.title}>Aleta</h1>
                <p style={styles.text}>Obrint l'app...</p>

                {showFallback ? (
                    <div style={styles.actions}>
                        <a href={appUrl} style={styles.button}>Obrir a l'app</a>
                        <p style={styles.help}>Si no s'obre automàticament, fes clic al botó.</p>
                    </div>
                ) : null}
            </div>
        </div>
    );
}

const styles = {
    page: {
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f7fb',
        color: '#111',
        padding: 24,
        boxSizing: 'border-box',
    },
    container: {
        width: '100%',
        maxWidth: 420,
        textAlign: 'center',
        backgroundColor: 'white',
        borderRadius: 8,
        padding: 28,
        boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
    },
    title: {
        margin: '0 0 12px',
        fontSize: 28,
    },
    text: {
        margin: 0,
        fontSize: 16,
        color: '#444',
    },
    actions: {
        marginTop: 24,
    },
    button: {
        display: 'inline-block',
        padding: '12px 18px',
        borderRadius: 6,
        backgroundColor: '#2859A8',
        color: 'white',
        textDecoration: 'none',
        fontWeight: 600,
    },
    help: {
        marginTop: 14,
        color: '#666',
        fontSize: 14,
    },
};

export default DeepLinkRedirect;
